export default {
  'OrdersActionTableHeader.Buttons.AssignToTech': ({}, outlet) => {
    outlet({ action: 'assign_tech' });
  },
  'OrdersActionTableHeader.Buttons.AssignToVendor': ({}, outlet) => {
    outlet({ action: 'assign_vendor' });
  },
  'OrdersActionTableHeader.Buttons.CancelOrders': ({}, outlet) => {
    outlet({ action: 'cancel' });
  },
  'OrdersActionTableHeader.Buttons.UnassignOrders': ({}, outlet) => {
    outlet({ action: 'unassign' });
  },
  'OrdersActionTableHeader.Buttons.ClearPostErrors': ({ disabled }, outlet) => {
    if (disabled) return;
    outlet({ action: 'clear_post_errors' });
  },
  'OrdersActionTableHeader.Buttons.RepostOrders': ({ disabled }, outlet) => {
    if (disabled) return;
    outlet({ action: 'repost_orders' });
  },
  'OrdersActionTableHeader.Buttons.CompleteOrdersWrapper.CompleteVendorOrders': ({ disabled }, outlet) => {
    if (disabled) return;
    outlet({ action: 'complete_vendor' });
  },
  'OrdersActionTableHeader.Buttons.ReopenOrders': ({}, outlet) => {
    outlet({ action: 'reopen' });
  },
  'OrdersActionTableHeader.Checkbox.Checkbox': ({}, outlet) => {
    outlet({ action: 'toggle' });
  },
  'OrdersActionTableHeader.Checkbox.Button': ({}, outlet) => {
    outlet({ action: 'empty_selection' });
  }
};
